import {
  DOCUMENTS__DOCUMENT_REUSE_FAILURE,
  DOCUMENTS__DOCUMENT_REUSE_REQUEST,
} from '@app/store/actionTypes';
import { DocumentsAction } from '@app/store/documents/actions';

type DocumentExtensionState = string | null;

const initialState: DocumentExtensionState = null;

export default function reducer(
  state: DocumentExtensionState = initialState,
  action: DocumentsAction
) {
  switch (action.type) {
    case DOCUMENTS__DOCUMENT_REUSE_REQUEST:
      return 'pdf';
    case DOCUMENTS__DOCUMENT_REUSE_FAILURE:
      return initialState;
    default:
      return state;
  }
}
